<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="服务网点" prop="nursinghomeId">
              <el-select
                disabled
                v-model="form.nursinghomeId"
                style="width: 100%"
                placeholder="请选择服务网点"
                @change="nursinghomeIdChange"
              >
                <el-option
                  v-for="item in nursinghomeIdList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
              <el-form-item label="项目名称" prop="nursinghomeId">
                <el-select
                disabled
                v-model="form.nursinghomeId"
                style="width:100%"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in nursinghomeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              </el-form-item>
            </el-col> -->

          <el-col :span="12">
            <el-form-item label="老人姓名" prop="name">
              <el-input
                clearable
                :disabled="model === 'view'"
                v-model="form.name"
                placeholder="请输入老人姓名"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="身份证号" prop="idNumber">
              <el-input
                clearable
                :disabled="model === 'view'"
                v-model="form.idNumber"
                placeholder="请输入身份证号"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性别" prop="sex">
              <el-radio-group :disabled="model === 'view'" v-model="form.sex">
                <el-radio :label="'1'">男</el-radio>
                <el-radio :label="'0'">女</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="自理情况" prop="selfCareCondition">
              <el-select
                placeholder="请选择自理情况"
                v-model="form.selfCareCondition"
                :disabled="model === 'view'"
                style="width: 100%"
              >
                <el-option
                  v-for="item in selfCareConditionList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="家庭住址" prop="address">
              <el-input
                clearable
                :disabled="model === 'view'"
                v-model="form.address"
                placeholder="请输入家庭住址"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="咨询人姓名" prop="consultantName">
              <el-input
                clearable
                :disabled="model === 'view'"
                v-model="form.consultantName"
                placeholder="请输入咨询人姓名"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="与老人关系" prop="relationship">
              <el-select
                placeholder="请选择与老人关系"
                v-model="form.relationship"
                :disabled="model === 'view'"
                style="width: 100%"
              >
                <el-option
                  v-for="item in relationshipList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="咨询日期" prop="consultTime">
              <el-date-picker
                placeholder="请选择咨询日期"
                style="width: 100%"
                :disabled="model === 'view'"
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="form.consultTime"
                type="datetime"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="咨询方式" prop="consultWay">
              <el-select 
                placeholder="请选择咨询方式"
              v-model="form.consultWay" :disabled="model === 'view'" style="width: 100%">
                <el-option
                  v-for="item in consultWayTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="媒体渠道" prop="mediaChannel">
              <el-select
                placeholder="请选择媒体渠道"
                v-model="form.mediaChannel"
                :disabled="model === 'view'"
                style="width: 100%"
              >
                <el-option
                  v-for="item in mediaChannelTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="咨询类型" prop="consultType">
              <el-select
                placeholder="请选择咨询类型"
                v-model="form.consultType"
                :disabled="model === 'view'"
                style="width: 100%"
              >
                <el-option
                  v-for="item in consultTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="tel">
              <el-input
                placeholder="请输入联系电话"
                v-model="form.tel"
                maxlength="20"
                :disabled="model === 'view'"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="接待人" prop="receiver">
              <el-input
                placeholder="请输入接待人"
                v-model="form.receiver"
                maxlength="50"
                :disabled="model === 'view'"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="咨询内容" prop="consultContent">
              <el-input
                placeholder="请输入咨询内容"
                type="textarea"
                v-model="form.consultContent"
                maxlength="200"
                :disabled="model === 'view'"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="text-align: right" v-if="model != 'view'">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        {{ model === 'add' ? '提交' : '修改' }}
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small"> 取消 </el-button>
    </div>
  </div>
</template>
  <script>
import { getProjectList } from '@/api/crmedical/project/project';
import { getDictionary } from '@/api/common.js';
import {
  getMatetial,
  getTotalWarehouseWarnSetting,
  stockWarnSave,
  stockWarnUpdate,
  getWarehouseWarnSetting,
  getNursinghome
} from '../api/serveItemManage';
export default {
  components: {},
  props: {
    row: {
      default: {},
    },
    nursinghomeId: {},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      projectList: [],

      form: {
        nursinghomeId: '',
        name: '',
        idNumber: '',
        sex: '',
        selfCareCondition: '',
        address: '',
        consultantName: '',
        relationship: '',
        consultTime: '',
        consultWay: '',
        mediaChannel: '',
        consultType: '',
        tel: '',
        receiver: '',
        consultContent: '',
      },
      formRules: {
        nursinghomeId: [{ required: true, message: '服务网点不能为空', trigger: 'change' }],
        name: [{ required: true, message: '老人名称不能为空', trigger: 'change' }],
        consultantName: [{ required: true, message: '咨询人姓名不能为空', trigger: 'change' }],
        consultWay: [{ required: true, message: '咨询方式不能为空', trigger: 'change' }],
        consultType: [{ required: true, message: '咨询类型不能为空', trigger: 'change' }],
        receiver: [{ required: true, message: '接待人不能为空', trigger: 'change' }],
      },
      selfCareConditionList: [],
      relationshipList: [],
      consultWayTypeList: [],
      mediaChannelTypeList: [],
      consultTypeList: [],
      nursinghomeIdList: [],
    };
  },
  created() {
    console.log(this.model);
    console.log(this.row);
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
    validate(val) {
      return (rule, value, callback) => {
        var reg = /^[0-9]{0,8}?$/;
        if (this.vdui.isNotEmpty(value)) {
          let flag = reg.test(value);
          if (!flag) {
            callback(new Error('请输入0-99,999,999的整数'));
          }
        }
        if (this.vdui.isNotEmpty(val) && this.vdui.isNotEmpty(value)) {
          if (Number(value) > Number(val)) {
            callback(new Error('下限不能大于上限'));
          } else {
            callback();
          }
        } else {
          callback();
        }
      };
    },
    validate2(val) {
      return (rule, value, callback) => {
        var reg = /^[0-9]{0,8}?$/;
        if (this.vdui.isNotEmpty(value)) {
          let flag = reg.test(value);
          if (!flag) {
            callback(new Error('请输入0-99,999,999的整数'));
          }
        }
        console.log(val, value);
        if (this.vdui.isNotEmpty(val) && this.vdui.isNotEmpty(value)) {
          if (Number(value) < Number(val)) {
            callback(new Error('上限不能小于下限'));
          } else {
            callback();
          }
        } else {
          callback();
        }
      };
    },
    consumableIdChange() {
      this.form.warehouseList = [];

      if (this.form.consumableId != '') {
        getWarehouseWarnSetting({
          projectId: this.form.projectId,
          type: '0',
          consumableId: this.form.consumableId,
        }).then((res) => {
          this.form = res.data;

          this.form.type = 0;
        });
      }
    },
    async initData() {
      
      getNursinghome({ id: this.nursinghomeId }).then(res=>{
        this.nursinghomeIdList = res.data;
        this.form.nursinghomeId = this.nursinghomeId;
      })
      if (this.model !== 'add') {
        this.form = this._.cloneDeep(this.row);;
      }
      getDictionary('nursinghome_self_care_type').then((res) => {
        this.selfCareConditionList = res.data;
      });
      getDictionary('nursinghome_relationship_type').then((res) => {
        this.relationshipList = res.data;
      });
      getDictionary('nursinghome_consult_way_type').then((res) => {
        this.consultWayTypeList = res.data;
      });
      getDictionary('nursinghome_media_channel_type').then((res) => {
        this.mediaChannelTypeList = res.data;
      });
      getDictionary('nursinghome_consult_type').then((res) => {
        this.consultTypeList = res.data;
      });
      if (this.model == 'add') {
        this.form.projectId = this.projectId;
      } else {
      }
      console.log('this.model===========>', this.model);
    },
    saveRecord() {
      if (this.model === 'add') {
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            stockWarnSave(this.form).then((res) => {
              this.$message.success('配置成功');
              this.$emit('success');
            });
          }
        });
      } else {
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            stockWarnUpdate(this.form).then((res) => {
              this.$message.success('操作成功');
              this.$emit('success');
            });
          }
        });
      }
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
  <style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
  